import React, { useState, useEffect } from 'react'
import { Tabs } from 'antd'
import { useLocation } from 'react-router-dom'
import CandidateMetrics from 'modules/CandidateMetrics/Container/index'
import CandidateMetricMain from './CandidateMetricMain'
import { SectionWrapper, TopHeader, TopHeading } from 'modules/Corporates/Style/style'
import { analyticsSession } from 'utils/analyticsSession'

const { TabPane } = Tabs

const CandidateMetricDetails = () => {
  const { search } = useLocation()
  const [activeTab, setActiveTab] = useState(() => {
    const openTab = analyticsSession.candidates?.openTab
    return openTab || (search ? 'main' : 'inventory')
  })

  useEffect(() => {
    const openTab = analyticsSession.candidates?.openTab
    if (openTab) setActiveTab(openTab)
    else if (search) setActiveTab('main')
  }, [search])

  return (
    <SectionWrapper column>
      <TopHeader row spaceBetween alignCenter>
        <TopHeading flexStart>Candidates List</TopHeading>
      </TopHeader>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        style={{ padding: '0 16px' }}
        destroyInactiveTabPane={false}
      >
        <TabPane tab="Mismatched Candidates" key="inventory">
          <CandidateMetrics />
        </TabPane>

        <TabPane tab="Live Candidates" key="main">
          <CandidateMetricMain />
        </TabPane>
      </Tabs>
    </SectionWrapper>
  )
}

export default CandidateMetricDetails